import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Woman.css";

const normalizeString = (str) => {
  return str
    .replace(/[\u0621\u0622\u0623\u0624\u0625\u0626]/g, "ا")
    .replace(/[\u064A]/g, "ي")
    .replace(/[\u0649]/g, "ي")
    .replace(/[\u064E\u0650\u0652\u064B\u064C\u064D]/g, "");
};

export default function Woman() {
  const [graves, setGraves] = useState([]);
  const [searchTerm, setSearchTerm] = useState(
    sessionStorage.getItem("womanSearchTerm") || ""
  );
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGraves = async () => {
      try {
        const response = await fetch(
          "https://cemetery-management.vercel.app/api/graves/female"
        );
        const data = await response.json();
        setGraves(data);
      } catch (error) {
        console.error("Error fetching female graves:", error);
      }
    };
    fetchGraves();
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    sessionStorage.setItem("womanSearchTerm", value);
  };

  const goToGraveDetails = (graveId) => {
    sessionStorage.setItem("womanSearchTerm", searchTerm);
    navigate(`/grave-details-user/${graveId}`);
  };

  const filteredGraves = graves.filter((grave) => {
    const normalizedSearchTerm = normalizeString(searchTerm);

    return (
      grave.buriedPersons.some((person) =>
        normalizeString(person.name).includes(normalizedSearchTerm)
      ) ||
      grave.number.toString().includes(normalizedSearchTerm) ||
      normalizedSearchTerm === ""
    );
  });

  return (
    <div className="woman-container">
      <input
        type="text"
        placeholder="ابحث عن اسم الشخص أو رقم المقبرة...."
        value={searchTerm}
        onChange={handleSearchChange}
        className="search-input"
      />

      {filteredGraves.length > 0 ? (
        filteredGraves.map((grave) => (
          <div
            key={grave._id}
            className={`grave-card ${
              grave.status === "متاحة" ? "available" : "not-available"
            }`}
            onClick={() => goToGraveDetails(grave._id)} // ✅ الكارت نفسه قابل للضغط
            style={{ cursor: "pointer" }} // شكل المؤشر يتغير عند المرور
          >
            <h2>رقم المقبرة: {grave.number}</h2>
            <p>الحالة: {grave.status}</p>
            <p>
              متاح بعد:{" "}
              {grave.status === "متاحة"
                ? "الآن"
                : `${grave.daysUntilAvailable} يوم`}
            </p>

            <button
              className="btn btn-primary p-2"
              onClick={(e) => {
                e.stopPropagation(); // ✅ عشان الكارت ما يضغطش مرتين
                goToGraveDetails(grave._id);
              }}
            >
              عرض المزيد
            </button>
          </div>
        ))
      ) : (
        <p className="no-results-message">لا توجد نتائج مطابقة للبحث.</p>
      )}
    </div>
  );
}
